
// Query for the first skeleton block
let skeleton = document.querySelector('.skeleton');

// Everthing else is not necassary if not skeleton block is found on current page
if (skeleton) {

    // Query for all dots and associated lists
    let allDots = skeleton.querySelectorAll('.skeleton-dot');
    let skeletonList = skeleton.querySelectorAll('.skeleton-list');

    // Breakup desktop and mobile dots into separate collections
    let desktopDots = skeleton.querySelectorAll('.desktop .skeleton-dot');
    let mobileDots = skeleton.querySelectorAll('.mobile .skeleton-dot');

    // Get the first dots to set active
    let firstDesktopDot;
    if (desktopDots && desktopDots.length) {
        firstDesktopDot = desktopDots[0];
    }
    let firstMobileDot;
    if (mobileDots && mobileDots.length) {
        firstMobileDot = mobileDots[0];
    }

    // Set initial active dot
    if (firstDesktopDot) {
        firstDesktopDot.classList.add('active');
       // firstMobileDot.classList.add('active');
    }

     if (firstMobileDot) {
     //   firstDesktopDot.classList.add('active');
        firstMobileDot.classList.add('active');
    }

    // Add animation class
    if (allDots) {
        window.onload = function () {
            [].forEach.call(allDots, function (dot) {
                dot.classList.add('animateIn');
                dot.addEventListener('animationstart', function () {
                    dot.classList.remove('animationStart');
                });
                dot.addEventListener('animationend', function () {
                    dot.classList.remove('animateIn');
                    dot.classList.add('animationEnd');
                });
            });
        };
    }

    // Click dot to make active
    if (allDots) {
        [].forEach.call(allDots, function (dot) {
            dot.addEventListener('click', function () {
                [].forEach.call(allDots, function (dot) {
                    dot.classList.remove('active');
                });
                dot.classList.add('active');
            });
        });
    }
    
    if (skeleton) {
        setSkeletonHeightMobile();
        setArticleListPosition();
    }

    // Resize event handler and function calls
    let isSkeletonPreviewPage = document.querySelector('.skeleton-preview');
    window.addEventListener('resize', function () {
        if (skeleton) {
            window.requestAnimationFrame(setSkeletonHeightMobile);
        }
        if (skeleton && !isSkeletonPreviewPage) {
            window.requestAnimationFrame(setArticleListPosition);
        }
    });

    // Set lists position
    function setArticleListPosition() {
        if (window.innerWidth > 1000) {
            let leftCoord = skeleton.getAttribute('data-listleftcoordinate');
            let topCoord = skeleton.getAttribute('data-listtopcoordinate');
            [].forEach.call(skeletonList, function (list) {
                list.style.left = leftCoord;
                list.style.top = topCoord;
            });
        }
    }

    // Dynamic height / mobile and tablet (list is abs. pos, block needs dynamic height of lists)
    function setSkeletonHeightMobile() {

        if (window.innerWidth <= 1000) {

            let dots = (window.innerWidth > 640) ? desktopDots : mobileDots;

            [].forEach.call(dots, function (dot) {

                function updatePadding() {
                    let correspondingListHeight = dot.nextElementSibling.getBoundingClientRect().height;
                    if (window.innerWidth <= 1000) {
                        skeleton.style.paddingBottom = correspondingListHeight + 'px';
                    } else {
                        skeleton.style.paddingBottom = '';
                    }
                }

                if (dot.classList.contains('active')) { // Initial state
                    updatePadding();
                }

                dot.addEventListener('click', function () { // State changes
                    updatePadding();
                });

            });
        } else {

            skeleton.style.paddingBottom = '';

        }
    }

}